import { Crumb } from '@liveauctioneers/caterwaul-components/lib/Breadcrumbs/Breadcrumbs';
import { getCategoryLevels } from '@/utils/categoryGrabber';
import { getItemFacets } from '@/redux/modules/itemFacets';
import { useAppSelector } from '@/redux/hooks';
import { useMemo } from 'react';

const useItemPageCategoryBreadcrumbs = (itemId: number): Crumb[] => {
    const { categories, creators = [] } = useAppSelector((state) => getItemFacets(state, itemId));

    return useMemo(() => {
        const crumbs: Crumb[] = [];
        const creator = creators[0] || null;
        let categoryLevels = [];

        if (categories) {
            categoryLevels = getCategoryLevels(categories[0]);
        }

        for (let i = 0; i < categoryLevels.length; i += 1) {
            if (categoryLevels[i].categoryName && categoryLevels[i].categoryUrl) {
                crumbs.push({
                    label: categoryLevels[i].categoryName,
                    link: `/c/${categoryLevels[i].categoryUrl}/${categoryLevels[i].categoryId}/`,
                });
            }
        }

        if (categoryLevels.length > 0 && creator) {
            const lastCategory = categoryLevels[categoryLevels.length - 1];
            if (lastCategory.categoryName && lastCategory.categoryUrl) {
                crumbs.push({
                    label: `${creator.l1CategoryName} ${lastCategory.categoryName}`,
                    link: `/c/${lastCategory.categoryUrl}/${creator.l1CategoryUrl}/${lastCategory.categoryId}/${creator.l1CategoryId}/`,
                });
            }
        }

        return crumbs;
    }, [categories, creators]);
};

export default useItemPageCategoryBreadcrumbs;
